import { render, staticRenderFns } from "./AddNewRole.vue?vue&type=template&id=ce8be222&scoped=true"
import script from "./AddNewRole.vue?vue&type=script&lang=js"
export * from "./AddNewRole.vue?vue&type=script&lang=js"
import style0 from "./AddNewRole.vue?vue&type=style&index=0&id=ce8be222&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8be222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce8be222')) {
      api.createRecord('ce8be222', component.options)
    } else {
      api.reload('ce8be222', component.options)
    }
    module.hot.accept("./AddNewRole.vue?vue&type=template&id=ce8be222&scoped=true", function () {
      api.rerender('ce8be222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/roleApi/AddNewRole.vue"
export default component.exports